<template>
	<app-page labelledby="initial-transfers-title">
		<page-header
			title-id="initial-transfers-title"
			title="Первоначальные остатки"
			description="Ввод начальных остатков по счетам организации."
		>
			<template v-if="!entityState" #actions>
				<q-btn color="primary" no-caps icon="add" label="Добавить остаток" @click="addRowDialog = true" />
			</template>
		</page-header>
		<app-state
			v-if="entityState"
			:state="entityState"
			title="Не удалось загрузить первоначальные остатки"
			:message="entityMessage"
			action-label="Вернуться к настройкам бухгалтерии"
			:action-to="{ name: 'org_profile_buh_automatic' }"
		/>
		<template v-else>
		<form-section title="Остатки по счетам" description="Суммы и аналитика сохраняются в форме первоначальных остатков.">
		<q-table v-accessible-scroll-region="{ label: 'Первоначальные остатки', selector: '.q-table__middle' }" flat wrap-cells="" borderless :rows="table_rows" :columns="table_columns" row-key="id"
			:pagination="initialPagination" :loading="loading">
			<template v-slot:body-cell-status="props">
				<q-td :props="props">
					<q-chip :color="getStatusColor(props.value)" text-color="white">
						{{ getStatusVerbose(props.value) }}
					</q-chip>
				</q-td>
			</template>
			<template v-slot:body-cell-summ="props">
				<q-td :props="props">
					<q-chip dense color="info" text-color="white">
						{{ formatMoney(props.value) }} руб.
					</q-chip>
				</q-td>
			</template>

			<template v-slot:body-cell-count="props">
				<q-td :props="props">
					<q-chip dense color="grey" text-color="white">
						{{ props.value || "Не указано" }}
					</q-chip>
				</q-td>
			</template>
			<template v-slot:body-cell-bill_to="props">
				<q-td :props="props">
					{{ (props.value || {full_name: ''} ).full_name }}
				</q-td>
			</template>

			<template v-slot:body-cell-bill="props">
				<q-td :props="props">
					{{ (props.value || { full_name: '' }).full_name }}
				</q-td>
			</template>


			<template v-slot:body-cell-direction="props">
				<q-td :props="props">
					<q-chip color="info" text-color="white">
						{{ (props.value || { label: '' }).label }}
					</q-chip>
				</q-td>
			</template>

			<template v-slot:body-cell-bill_from="props">
				<q-td :props="props">
					{{ (props.value || { full_name: '' }).full_name }}
				</q-td>
			</template>

			<template v-slot:body-cell-filter_field="props">
				<q-td :props="props">
					{{ props.value.label }}
				</q-td>
			</template>
			<template v-slot:body-cell-actions="props">
				<q-td :props="props">
					<q-btn flat round color="primary" icon="info" @click="showInfo(props.row)">
						<q-tooltip>Информация об остатке</q-tooltip>
					</q-btn>
				</q-td>
			</template>
		</q-table>
		<q-dialog v-model="addRowDialog" persistent>
			<q-card class="initial-transfer-dialog">
				<q-card-section>
					<div v-if="edit_mode" class="text-h6">Изменить остаток</div>
					<div v-else class="text-h6">Добавить остаток</div>
				</q-card-section>

				<q-card-section>
					<q-list>
						<q-item>
							<q-item-section>
								<q-item-label>
									<q-input dense flat label="Дата" v-model="new_transfer_date">
										<template v-slot:append>
											<q-icon name="event" class="cursor-pointer" role="button" tabindex="0" aria-label="Выбрать дату" @keydown.enter.prevent="$event.currentTarget.click()" @keydown.space.prevent="$event.currentTarget.click()">
												<q-popup-proxy cover transition-show="scale" transition-hide="scale">
													<q-date mask="DD.MM.YYYY" v-model="new_transfer_date"
														@update:model-value="(newValue) => onDateChanged(newValue)">
														<div class="row items-center justify-end">
															<q-btn v-close-popup label="Закрыть" color="primary" flat />
														</div>
													</q-date>
												</q-popup-proxy>
											</q-icon>
										</template>
									</q-input>
								</q-item-label>
							</q-item-section>
						</q-item>
						<q-item>
							<q-item-section>
								<q-item-label>
									<q-input :model-value="moneyInput(new_summ, 'new_summ')" @update:model-value="setMoney('new_summ', $event)" @blur="finishMoney('new_summ')" type="number" label="Сальдо на начало периода"
										:rules="[() => !!new_summ || 'Поле обязательно для заполнения']" />
								</q-item-label>
							</q-item-section>
						</q-item>
						<q-item>
							<q-item-section>
								<q-item-label>
									<q-select v-model="new_bill" :options="bills_list" label="Счет"
										:rules="[val => !!val || 'Поле обязательно для заполнения']"
										@update:model-value="onBillChanged" />
								</q-item-label>
							</q-item-section>
						</q-item>
						<q-item>
							<q-item-section>
								<q-item-label>
									<q-select v-model="new_transfer_direction" :options="direction_options"
										label="Тип остатка"
										:rules="[val => !!val || 'Поле обязательно для заполнения']" />
								</q-item-label>
							</q-item-section>
						</q-item>
						<q-item>
							<q-item-section>
								<q-item-label>
									<q-input v-model="new_comment" type="text" label="Коментарий" />
								</q-item-label>
							</q-item-section>
						</q-item>
						<q-item v-show="show_fields_filter.includes('seller_inn')">
							<q-item-section>
								<q-item-label>
									<q-input v-model="new_field_seller_inn"
										:rules="[val => !!val || 'Поле обязательно для заполнения']"
										label="ИНН продавца" />
								</q-item-label>
							</q-item-section>
						</q-item>
						<q-item v-show="show_fields_filter.includes('cust_inn')">
							<q-item-section>
								<q-item-label>
									<q-input v-model="new_field_cust_inn"
										:rules="[val => !!val || 'Поле обязательно для заполнения']"
										label="ИНН покупателя" />
								</q-item-label>
							</q-item-section>
						</q-item>
						<q-item v-show="show_fields_filter.includes('name_id')">
							<q-item-section>
								<q-item-label>
									<q-input v-model="new_field_name_id"
										:rules="[val => !!val || 'Поле обязательно для заполнения']" label="Товар" />
								</q-item-label>
							</q-item-section>
						</q-item>
						<q-item >
							<q-item-section>
								<q-item-label>
									<q-input v-model="new_field_count"
										:rules="[val => !!val || 'Поле обязательно для заполнения']" type="number"
										label="Количество" />
								</q-item-label>
							</q-item-section>
						</q-item>
						<q-item v-show="show_fields_filter.includes('account')">
							<q-item-section>
								<q-item-label>
									<q-input v-model="new_field_account"
										:rules="[val => !!val || 'Поле обязательно для заполнения']" type="number"
										label="Расчетный счет" />
								</q-item-label>
							</q-item-section>
						</q-item>
					</q-list>
				</q-card-section>

				<q-card-actions align="right">
					<q-btn v-show="edit_mode" flat label="Удалить" color="primary" @click="delete_transfer" />
					<q-btn v-if="edit_mode" flat label="Сохранить" color="primary" @click="add_transfer" />
					<q-btn v-else flat label="Добавить" color="primary" @click="add_transfer" />
					<q-btn flat label="Закрыть" color="primary" v-close-popup />
				</q-card-actions>
			</q-card>
		</q-dialog>
		</form-section>
		</template>
	</app-page>
</template>

<script>
import { formatMoney } from '../../../services/moneyFormat'
import { ref } from "vue";
import moment from "moment";
import AppState from '../../../components/ui/AppState.vue'
import AppPage from '../../../components/ui/AppPage.vue'
import FormSection from '../../../components/ui/FormSection.vue'
import PageHeader from '../../../components/ui/PageHeader.vue'

const table_columns = [
	{ name: 'summ', align: 'left', label: 'Сальдо на начало', field: 'summ' },
	{ name: 'date', align: 'left', label: 'Дата', field: 'date' },
	{ name: 'bill', align: 'left', label: 'Счет', field: 'bill' },
	{ name: 'direction', align: 'left', label: 'Тип остатка', field: 'direction' },
	{ name: 'comment', align: 'left', label: 'Коментарий', field: 'comment' },
	{ name: 'seller_inn', align: 'left', label: 'Продавец', field: 'seller_inn' },
	{ name: 'cust_inn', align: 'left', label: 'Покупатель', field: 'cust_inn' },
	{ name: 'name_id', align: 'left', label: 'Товар', field: 'name_id' },
	{ name: 'count', align: 'left', label: 'Количество', field: 'count' },
	{ name: 'status', align: 'left', label: 'Статус', field: 'status' },
	{ name: 'actions', label: 'Действия', field: 'actions' }
]

const filter_field_options = [
	{ label: 'Продавец', value: 'seller_inn' },
	{ label: 'Покупатель', value: 'cust_inn' },
	{ label: 'Товар', value: 'name_id' }
];

// const filter_field_options_51 = [
// 	{ label: 'Расчетный счет', value: 'account' }
// ];


const direction_options = [
	{ label: 'Дебет', value: 'debet' },
	{ label: 'Кредит', value: 'credit' },
];

export default {
	name: "initial_transfers_master",
	components: { AppPage, AppState, FormSection, PageHeader },
	data() {

		if (this.connection.isAuthenticated) {
			this.connection.gitBillsListFlatCompact(
				'1'
			);
			this.connection.listOpeningTransfers(
				'1'
			);
		} else {
			this.emitter.on('connectionReady', () => {
				this.connection.gitBillsListFlatCompact(
					'1'
				);
				this.connection.listOpeningTransfers(
					'1'
				);
			});
		}
		this.emitter.on('onListOpeningTransfers', (data) => {
			if (data.type === 'error' || !Array.isArray(data.transfers)) {
				this.setEntityError(data.message || 'Сервер вернул некорректные данные первоначальных остатков');
				return;
			}
			this.table_rows = data.transfers.map((element) => {
				return {
                    ...element,
                    bill: element.bill_to != null ? element.bill_to : element.bill_from,
					direction: element.bill_to != null ? this.direction_options[0] : this.direction_options[1],
                }
			});
		});
		this.emitter.on('onUpdateOpeningTransfer', () => {
			this.connection.listOpeningTransfers(
				'1'
			);
		});
		this.emitter.on('onDeleteTransfer', () => {
			this.connection.listOpeningTransfers(
				'1'
			);
		});
		this.emitter.on('didReceiveBillListFlatCompact', (data) => {
			if (data.type === 'error' || !Array.isArray(data.bills)) {
				this.setEntityError(data.message || 'Сервер вернул некорректный список счетов');
				return;
			}
			this.bills_list = data.bills.map((element => {
				return {
					label: element.display_name,
					full_name: element.full_name,
					value: element.id,
					filters: element.analytic && Array.isArray(element.analytic.fields) ? element.analytic.fields : []
				}
			}));
		})
		this.emitter.on('onCreateOpeningTransfer', (response) => {
			if (response.type == 'error') {
				this.$q.notify(response.message || 'Ошибка');
			} else {
				this.connection.listOpeningTransfers(
					'1'
				);
				this.$q.notify('Остатки успешно внесены');
			}
            this.$q.loading.hide();
		});
		this.emitter.on('didCreateNewSubbill', () => {
			this.connection.gitBillsListFlatCompact(
				'1'
			);
		});
		return {
			filter_field_options: ref(filter_field_options),
			table_columns: ref(table_columns),
			table_rows: ref([]),
			new_id: ref(1),
			new_name: ref(null),
			new_summ: ref(null),
			editingMoney: '',
			new_bill: ref(null),
			new_bill_to: ref(null),
			new_bill_from: ref(null),
            new_comment: ref(null),
            new_field_seller_inn: ref(null),
			new_field_cust_inn: ref(null),
			new_field_name_id: ref(null),
			new_transfer_date: ref(null),
			new_transfer_date_unix: ref(null),
			new_transfer_direction: ref(direction_options[0]),
			new_field_count: ref(null),
			direction_options: ref(direction_options),
			loading: ref(false),
			initialPagination: {
				sortBy: 'id',
				descending: false,
				page: 1,
				rowsPerPage: 100
			},
			addRowDialog: ref(false),
			bills_list: ref([]),
			edit_mode: ref(false),
			show_fields_filter: ref([]),
			entityState: ref(null),
			entityMessage: ref(''),
		}
	},
	methods: {
		formatMoney,
		moneyInput(value, field) {
			if (this.editingMoney === field) return value
			return formatMoney(value, { empty: '', invalid: String(value), useGrouping: false }).replace(',', '.')
		},
		setMoney(field, value) {
			this.editingMoney = field
			this[field] = value
		},
		finishMoney(field) {
			if (this.editingMoney === field) this.editingMoney = ''
		},
		setEntityError(message) {
			this.loading = false;
			this.$q.loading.hide();
			this.entityState = 'error';
			this.entityMessage = message;
		},
		onDateChanged(newValue) {
			this.new_transfer_date_unix = moment(newValue, 'DD.MM.YYYY').format('YYYY-MM-DD')
		},
		getStatusColor(status) {
			switch (String(status || '').toLowerCase()) {
				case 'new': return 'grey'
				case 'saved': return 'positive'
				case 'posted': return 'positive'
				case 'draft': return 'grey'
				case 'archived': return 'negative'
				case 'cancelled': return 'negative'
				case 'failed': return 'negative'
				default: return 'grey'
			}
		},
		getStatusVerbose(status) {
			switch (String(status || '').toLowerCase()) {
				case 'new': return 'Не сохранено'
				case 'saved': return 'Сохранено'
				case 'posted': return 'Проведено'
				case 'draft': return 'Не проведено'
				case 'archived': return 'В архиве'
				case 'cancelled': return 'Отменено'
				case 'failed': return 'Ошибка'
				default: return 'Неизвестно'
			}
		},
		add_transfer() {
			if (this.edit_mode) {
				const item = {
					id: this.new_id,
					name: this.new_name,
					summ: this.new_summ,
					bill_to: this.new_transfer_direction.value == 'debet' ? this.new_bill : null,
					bill_from: this.new_transfer_direction.value == 'credit' ? this.new_bill : null,
					comment: this.new_comment,
					seller_inn: this.new_field_seller_inn,
					cust_inn: this.new_field_cust_inn,
					name_id: this.new_field_name_id,
					date: this.new_transfer_date,
					date_unix: this.new_transfer_date_unix,
					status: 'new',  // 'new', 'saved', 'failed',
					count: parseInt(this.new_field_count),
				}
				this.connection.updateOpeningTransfer(
					'1',
					item.id,
					{
						name: 'Внесение остатков',
						amount: item.summ,
						debit_account_id: item.bill_to !== null ? item.bill_to.value : null,
						credit_account_id: item.bill_from !== null ? item.bill_from.value : null,
						comment: item.comment,
						seller_inn: item.seller_inn,
						cust_inn: item.cust_inn,
						position_name: item.name_id,
						date: item.date_unix,
						count: item.count
					}
				)
			} else {
				const item = {
					id: this.table_rows.length + 1,
					name: this.new_name,
					summ: this.new_summ,
					bill_to: this.new_transfer_direction.value == 'debet' ? this.new_bill : null,
					bill_from: this.new_transfer_direction.value == 'credit' ? this.new_bill : null,
					comment: this.new_comment,
					seller_inn: this.new_field_seller_inn,
					cust_inn: this.new_field_cust_inn,
					name_id: this.new_field_name_id,
					date: this.new_transfer_date,
					date_unix: this.new_transfer_date_unix,
					status: 'new',  // 'new', 'saved', 'failed',
					count: parseInt(this.new_field_count)
				}
				this.table_rows.push(item);
				this.connection.createOpeningTransfer(
					'1',
					{
						name: 'Внесение остатков',
						amount: item.summ,
						debit_account_id: item.bill_to !== null ? item.bill_to.value : null,
						credit_account_id: item.bill_from !== null ? item.bill_from.value : null,
						comment: item.comment,
						seller_inn: item.seller_inn,
						cust_inn: item.cust_inn,
						position_name: item.name_id,
						date: item.date_unix,
						count: item.count,
						status: 'posted'
					}
				)
			}
			this.new_id = 0;
			this.new_name = null;
			this.new_summ = null;
			this.new_bill_to = null;
			this.new_bill_from = null;
			this.new_comment = null;
			this.new_field_seller_inn = null;
			this.new_field_cust_inn = null;
			this.new_field_name_id = null;
			this.new_bill = null;
			this.new_transfer_date = null;
			this.new_transfer_date_unix = null;
			this.addRowDialog = false;
			this.edit_mode = false;
		},
		showInfo(item) {
			this.new_id = item.id;
			this.new_name = item.name;
			this.new_summ = item.summ;
			this.new_bill_to = item.bill_to;
			this.new_bill_from = item.bill_from;
			this.new_comment = item.comment;
			this.new_field_seller_inn = item.seller_inn;
			this.new_field_cust_inn = item.cust_inn;
			this.new_field_name_id = item.name_id;
			if (item.bill_to) {
				this.new_bill = item.bill_to;
				this.new_transfer_direction = this.direction_options[0]
			} else {
				this.new_bill = item.bill_from;
				this.new_transfer_direction = this.direction_options[1]
			}
			this.new_transfer_date = item.date ? moment(item.date).format('DD.MM.YYYY') : null;
			this.new_transfer_date_unix = item.date ? moment(item.date).format('YYYY-MM-DD') : null;
			this.addRowDialog = true;
			this.edit_mode = true;
		},
		delete_transfer() {
			this.connection.deleteTransfer(
                '1',
                this.new_id
			)
			this.new_id = 0;
			this.new_name = null;
			this.new_summ = null;
			this.new_bill_to = null;
			this.new_bill_from = null;
			this.new_comment = null;
			this.new_field_seller_inn = null;
			this.new_field_cust_inn = null;
			this.new_field_name_id = null;
			this.new_bill = null;
			this.new_transfer_date = null;
			this.new_transfer_date_unix = null;
			this.addRowDialog = false;
			this.edit_mode = false;
		},
		onBillChanged(value) {
			this.show_fields_filter = value.filters.map((element) => {
				return element.value;
			});
		},
	}
}
</script>

<style scoped>
.initial-transfer-dialog { min-width: 21.875rem; }
</style>
